"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareAddresses = void 0;
const prepare_address_1 = require("./prepare-address");
function prepareAddresses(data, ...keys) {
    const result = Object.assign({}, data);
    for (const key of keys) {
        if (!result[key]) {
            continue;
        }
        try {
            if (Array.isArray(result[key])) {
                const addresses = result[key].map((item) => {
                    let result = item;
                    if (item) {
                        const address = (0, prepare_address_1.prepareAddress)(item);
                        if (address) {
                            result = address;
                        }
                    }
                    return result;
                });
                result[key] = addresses;
            }
            else {
                const address = (0, prepare_address_1.prepareAddress)(result[key]);
                if (address) {
                    result[key] = address;
                }
            }
        }
        catch (err) {
        }
    }
    return result;
}
exports.prepareAddresses = prepareAddresses;
